// Tour inclusions — shared by the builder (checkbox grid) and the detail page
// (icon grid + "What's included" list). `key` is what's stored on the tour.
const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const INCLUSIONS = [
  { key: 'lunch', label: 'Gourmet Lunch', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M5 13a7 7 0 0 1 14 0Z"/><line x1="3" y1="17" x2="21" y2="17"/><line x1="12" y1="6" x2="12" y2="6.01"/></svg>
  ) },
  { key: 'coffee', label: 'Coffee / Tea', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M17 8h1a4 4 0 1 1 0 8h-1"/><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/></svg>
  ) },
  { key: 'motorcycle', label: 'Motorcycle', icon: (
    <svg viewBox="0 0 24 24" {...S}><circle cx="5" cy="17" r="3"/><circle cx="19" cy="17" r="3"/><path d="M9 17l2-9h3l3 5.5"/><path d="M14 8l2-3h3"/><path d="M5 14l4-6"/></svg>
  ) },
  { key: 'fuel', label: 'Petrol / Fuel', icon: (
    <svg viewBox="0 0 24 24" {...S}><line x1="3" y1="22" x2="15" y2="22"/><line x1="4" y1="9" x2="14" y2="9"/><path d="M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"/><path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0V9.8a2 2 0 0 0-.6-1.4L18 5"/></svg>
  ) },
  { key: 'gear', label: 'Riding Gear', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M3 13a9 9 0 0 1 18 0v1H3Z"/><path d="M3 14h18v2a3 3 0 0 1-3 3h-4l-2 2-2-2H6a3 3 0 0 1-3-3Z"/></svg>
  ) },
  { key: 'guide', label: 'Tour Guide', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
  ) },
  { key: 'tolls', label: 'Road Tolls', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><line x1="13" y1="5" x2="13" y2="19" strokeDasharray="2 2"/></svg>
  ) },
  { key: 'insurance', label: 'Insurance', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="M9 12l2 2 4-4"/></svg>
  ) },
  { key: 'pickup', label: 'Pickup & Drop-off', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
  ) },
  { key: 'drinks', label: 'Drinks / Water', icon: (
    <svg viewBox="0 0 24 24" {...S}><path d="M6 3h12l-1.4 9a4.5 4.5 0 0 1-9 0Z"/><line x1="12" y1="21" x2="12" y2="16"/><line x1="8" y1="21" x2="16" y2="21"/></svg>
  ) },
];

export const INCLUSION_MAP = Object.fromEntries(INCLUSIONS.map(i => [i.key, i]));
